import { createSlice } from "@reduxjs/toolkit";
import { SaveAnswersState } from "interfaces";

const initialState: SaveAnswersState = {
  loaded: false,
  select: false,
  checkIds: [],
  saveAnswers: [],
  saveAnswersFiltered: [],
  currentAnswer: null,
};

const gestioneSaveAnswersSlice = createSlice({
  name: "gestioneSaveAnswersSlice",
  initialState,
  reducers: {
    setSaveAnswers: (state, action) => {
      state.saveAnswers = action.payload;
      state.saveAnswersFiltered = action.payload;
      state.loaded = true;
    },
    setFilterAnswers: (state, action) => {
      const keyword = action.payload.toLowerCase();
      state.saveAnswersFiltered = state.saveAnswers.filter((saveAnswer: any) =>
        saveAnswer.title.toLowerCase().includes(keyword)
      );
    },
    setSelect: (state, action) => {
      state.select = action.payload;
    },
    setTitleAnswer: (state, action) => {
      state.saveAnswersFiltered.forEach((answer: any) => {
        if (answer.id === action.payload.id) {
          answer.title = action.payload.title;
        }
      });
    },

    setToggleCheckId: (state, action) => {
      const id = action.payload;
      if (state.checkIds.includes(id)) {
        state.checkIds = state.checkIds.filter(
          (checkId: any) => checkId !== id
        );
      } else {
        state.checkIds.push(id);
      }
    },
    setAllToggle: (state, action) => {
      const checkIds = action.payload;
      checkIds.forEach((id: string) => {
        if (!state.checkIds.includes(id)) {
          state.checkIds.push(id);
        }
      });
    },
    resetCheckIds: (state) => {
      state.checkIds = [];
    },
    resetLoadedStatus: (state: any) => {
      state.loaded = false;
    },
    setCurrentAnswer: (state: any, action: any) => {
      state.currentAnswer = action.payload;
    },
    resetCurrentAnswer: (state: any) => {
      state.currentAnswer = initialState.currentAnswer;
    },
    resetInitialStateSaveAnswer: (_) => initialState,
  },
});

export const {
  setSaveAnswers,
  setSelect,
  resetLoadedStatus,
  setToggleCheckId,
  setAllToggle,
  resetCheckIds,
  resetInitialStateSaveAnswer,
  setFilterAnswers,
  setTitleAnswer,
  setCurrentAnswer,
  resetCurrentAnswer,
} = gestioneSaveAnswersSlice.actions;

export default gestioneSaveAnswersSlice.reducer;
